<div class="accordion" id="accordionExample">
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingSix">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseSix"
        aria-expanded="true"
        aria-controls="collapseSix"
        style="font-size: 13px"
      >
        Share for Review
      </button>
    </h2>
    <div
      id="collapseSix"
      class="accordion-collapse collapse"
      aria-labelledby="headingSix"
      data-bs-parent="#accordionExample"
    >

      <div class="accordion-body p-3">
        <app-share-review></app-share-review>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingFive">
      <button
        class="accordion-button"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseFive"
        aria-expanded="true"
        aria-controls="collapseFive"
        style="font-size: 13px"
      >
        Ask Airo
      </button>
    </h2>
    <div
      id="collapseFive"
      class="accordion-collapse collapse show"
      aria-labelledby="headingFive"
      data-bs-parent="#accordionExample"
    >
      <div class="accordion-body p-2">
        <app-airo-chat></app-airo-chat>
      </div>
    </div>
  </div>
  <div
    *ngIf="
      !user?.is_vendor &&
      user?.permissions?.indexOf('opportunity.add_opportunity') > -1
    "
    class="accordion-item"
  >
    <h2 class="accordion-header" id="headingZero">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseZero"
        aria-expanded="true"
        aria-controls="collapseOne"
        style="font-size: 13px"
      >
        {{displayLabels?.project | titlecase}}s sorted by tags
      </button>
    </h2>
    <div
      id="collapseZero"
      class="accordion-collapse collapse"
      aria-labelledby="headingZero"
      data-bs-parent="#accordionExample"
    >
      <div class="accordion-body p-2">
        <app-loading *ngIf="loading"></app-loading>
        <div
          class="browseai1-card"
          [ngStyle]="{ background: data.color }"
          *ngFor="let data of projects"
          (click)="openProjects(data)"
        >
          <div class="d-flex justify-content-between">
            <h6 class="project-info-text">
              {{ data.project_name }} | {{ data.portfolio }} |
              {{ data.sub_portfolio }} | {{ data.owner_name }}
            </h6>

            <mat-icon class="arrow-icon">call_made</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="accordion-item" *ngIf="activeHubbleInsight">
    <h2 class="accordion-header" id="headingTwo">
      <button
        class="accordion-button"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseTwo"
        aria-expanded="true"
        aria-controls="collapseTwo"
        style="font-size: 13px"
      >
        Hubble Insight
      </button>
    </h2>
    <div
      id="collapseTwo"
      class="accordion-collapse collapse"
      [class.show]="activeHubbleInsight"
      aria-labelledby="headingTwo"
      data-bs-parent="#accordionExample"
    >
      <div class="accordion-body p-2">
        <app-hubble-insights></app-hubble-insights>
      </div>
    </div>
  </div>
</div>
